/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DisablePipedriveInput = {|
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type DisablePipedriveMutationVariables = {|
  input: DisablePipedriveInput
|};
export type DisablePipedriveMutationResponse = {|
  +disablePipedrive: ?{|
    +company: ?{|
      +pipedriveCompanyDomain: ?string
    |}
  |}
|};
export type DisablePipedriveMutation = {|
  variables: DisablePipedriveMutationVariables,
  response: DisablePipedriveMutationResponse,
|};
*/


/*
mutation DisablePipedriveMutation(
  $input: DisablePipedriveInput!
) {
  disablePipedrive(input: $input) {
    company {
      pipedriveCompanyDomain
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DisablePipedriveInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pipedriveCompanyDomain",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DisablePipedriveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisablePipedrivePayload",
        "kind": "LinkedField",
        "name": "disablePipedrive",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DisablePipedriveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisablePipedrivePayload",
        "kind": "LinkedField",
        "name": "disablePipedrive",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "DisablePipedriveMutation",
    "operationKind": "mutation",
    "text": "mutation DisablePipedriveMutation(\n  $input: DisablePipedriveInput!\n) {\n  disablePipedrive(input: $input) {\n    company {\n      pipedriveCompanyDomain\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd124ffde2790ccbdc6fad915345b29a7';

module.exports = node;
